import { action } from 'lib/actionHelpers';
import { store } from 'redux/lib/configureStore';
import selectors from 'selectors/selectors';
import { putMessageStatus } from 'redux/actions/leadModalActions';
import { publishAction } from 'redux/actions/messagesActions';

const exclude = ['video_calls', 'todos', 'notes'];

export const autoMarkEventAsRead = () => {
  const state = store.getState();
  const messages = (selectors.chatMessages(state) || []).filter((n) => !exclude.includes(n.type)).filter((n) => n.outgoing !== '1');
  const reversedMessages = (messages || []).reverse();
  const lastUnreadEvent = (reversedMessages || []).find((n) => n.is_read === '0');
  if (lastUnreadEvent) {
    const payload = {
      is_read: '1',
      event_type: lastUnreadEvent.type,
    };

    const data = {
      event: 'count',
      key: `updateReadUnreadStateConversations`,
      message: {
        count: {
          currentFolder: lastUnreadEvent.status_id,
          is_read: payload.is_read,
        },
      },
    };

    putMessageStatus(lastUnreadEvent.id, payload, () => {
      const actionName = 'PATCH_MESSAGE_AS_READ';
      action(actionName, lastUnreadEvent.unique_id);
      publishAction({ data });
    });
  }
};
